import React from "react";
import { OrderUseContext } from "../../context/AdminDashboard/OrderContext";
import { HeaderNewOrderPage } from "../../data/TablesHeader";
import loading from "../../photos/Spinner-1.9s-137px.gif";
import SearchHeader from "../../components/main/SearchHeader";
import Table from "../../components/main/Table";
import DeleteModal from "../../components/atoms/DeleteModal";
import EditeOrderModal from "./EditeOrderModal";
const NewOrder = ({ gettext, buttonSearch }) => {
  const {
    NewOrderList,
    tableNewOrderLoaded,
    onediteNeworde,
    ondelete,
    name,
    closeDeleteModalnew,
    RemoveItemnew,
    showDeleteModalNew,
    doneEditNewOrder,
    newmodal,
    closeModal,
    modaldata,
    codeval,
    onchangeInput,
    changestatus,
    disable
  } = OrderUseContext();

  // console.log(disable)
  return (
    <div>
      <div
        className="mr-7.5px ml-7.5px mt-5 bg-white shadow-md rounded-sm pr-7.5px pl-7.5px pt-7.5px pb-7.5px  "
        dir="rtl">
        <SearchHeader
          title=" سفارش‌های جدید"
          number={"55"}
          buttnText="  افزودن سفارش جدید"
          placeholder="جست و جو: شماره تماس، نام"
          buttonSearch={buttonSearch}
          gettext={gettext}
          // onClick={AddClient}
          borderBlue="border-blue border-1"
          path={"/admin/order/add"}
        />
        {tableNewOrderLoaded ? (
          <div className="flex justify-center items-center w-24 h-203 m-auto bg-transparent">
            <img src={loading} alt="" />
          </div>
        ) : (
          <>
            <Table
              thData={HeaderNewOrderPage}
              tableData={NewOrderList}
              Hempty={"h-203"}
              emptyText={"سفارش جدیدی یافت نشد."}
              thwidth={"w-15"}
              onediteO={onediteNeworde}
              onDeleteR={ondelete}
              detailKey={"id"}
              deletetext={"حذف سفارش"}
              detailtext={" جزئیات سفارش"}
              edittext={"ویرایش سفارش"}
              detailTo={"/admin/order/log"}
            />
          </>
        )}
        <DeleteModal
          text={`آیا برای حذف “${name}” مطمئن هستید؟`}
          showDeleteModal={showDeleteModalNew}
          closeDeleteModal={closeDeleteModalnew}
          RemoveItem={RemoveItemnew}
          title="اخطار حذف سفارش"
        />
        <EditeOrderModal
          showModal={newmodal}
          closeModal={closeModal}
          modaldata={modaldata}
          codeval={codeval}
          showNewModal={true}
          onchangeInput={onchangeInput}
          onchangeselect={changestatus}
          doneEdit={doneEditNewOrder}
          disabled={disable}
        />
      </div>
    </div>
  );
};

export default NewOrder;
